import { isNoiseError } from './noiseErrors';
import type { NoisePattern } from './noiseErrors';
import type { EventFilter, TelemetryEvent } from './types';

/**
 * Drops `type === 'error'` events whose stack names a script matching a pattern.
 * Each stack line is matched on its own, so a pattern anchored with `^` binds to the start of a frame.
 */
export function dropByScriptUrl<T extends TelemetryEvent>(patterns: readonly NoisePattern[]): EventFilter<T> {
  return (event) => {
    if (event.type !== 'error' || patterns.length === 0) return true;
    return !event.error?.stack?.split('\n').some(line => isNoiseError(line, patterns));
  };
}
